import React, { FC, useState } from 'react';
import { Button, Input } from 'antd';
import { useTranslation } from 'react-i18next';

import { Form, FormDrawer } from '~/components';
import { EditIcon } from '~/img';
import { useChangeAccountAlias } from '~/hooks/accounts';
import { accounts } from '~/routes';
import { usePermissions } from '~/hooks';
import { Account } from '~/types';

interface Props {
  account: Account;
  reloadAccounts: () => void;
}

const EditAlias: FC<Props> = (props) => {
  const { account, reloadAccounts } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const id: string = account.id;
  const { mutate } = useChangeAccountAlias(reloadAccounts);
  const onFinish = (values: { alias: string }) => {
    mutate({ id, alias: values.alias });
    handleClose();
  };

  const [form] = Form.useForm();

  const [t] = useTranslation('accounts');
  const hasAccessUpdate = usePermissions('business.accounts.allias.update');
  if (!hasAccessUpdate) return null;
  return (
    <>
      <Button shape="default" onClick={handleOpen}>
        <EditIcon />
        {t('editAlias')}
      </Button>
      <FormDrawer
        name={accounts}
        onFinish={onFinish}
        title={t('editAlias')}
        onClose={handleClose}
        visible={open}
      >
        <Form form={form} layout="vertical" name={accounts} initialValues={account}>
          <Form.Item label={t('alias')} name="alias" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      </FormDrawer>
    </>
  );
};

export default EditAlias;
